"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const TinySaveIndicator_1 = require("../../../../../comps/reusables/TinySaveIndicator");
const graphql_1 = require("../../../../../graphql");
const SendStepPanel_1 = require("./SendStepPanel");
const react_2 = require("@osmosys/react");
const react_loops_1 = require("react-loops");
const react_if_1 = require("react-if");
const lib_1 = require("use-debounce/lib");
const react_hooks_1 = require("@apollo/react-hooks");
const react_hanger_1 = require("react-hanger");
const utils_1 = require("@osmosys/utils");
const hooks_1 = require("../../../../../hooks");
exports.SubjectLinesInput = ({ step, activeStep, defaultSubjectLine, allowableSubjectlines, disabled, emailId, onChange, onInvalid, onSaveComplete, onSavePending, onValid, subjectLines, }) => {
    const defaultSubjectLineIsInUse = react_1.useMemo(() => {
        return (defaultSubjectLine &&
            subjectLines &&
            !!subjectLines.find(sbjctLn => {
                return sbjctLn.trim() === defaultSubjectLine.trim();
            }));
    }, [...subjectLines, defaultSubjectLine]);
    const [requestBuffer, toggleRequestBuffer] = react_2.useTimedToggle(1000);
    const { featureFlags } = hooks_1.useOsmosysContext();
    const [save, saveResult] = react_hooks_1.useMutation(graphql_1.updateEmailLatestSubjectLines, {
        notifyOnNetworkStatusChange: false,
        onCompleted: () => {
            onSaveComplete();
            toggleRequestBuffer();
        },
        variables: {
            id: emailId,
            latestSubjectLines: subjectLines,
            useNewLoaderFeature: featureFlags.useNewLoaderForEmailSubjectLineMutation,
        },
    });
    const { error, loading, data } = saveResult;
    const isValid = react_1.useMemo(() => {
        if (!subjectLines || subjectLines.length === 0) {
            return false;
        }
        const joinedSubjectLines = subjectLines.join('');
        if (joinedSubjectLines.length === 0) {
            return false;
        }
        const emptySubjectLine = subjectLines.find(subjectLine => !subjectLine || subjectLine.length === 0);
        const longSubjectLine = subjectLines.find(subjectLine => subjectLine.length > 200);
        if (utils_1.isDefined(emptySubjectLine) || utils_1.isDefined(longSubjectLine)) {
            return false;
        }
        else {
            return true;
        }
    }, [...subjectLines]);
    const prevIsValid = react_hanger_1.usePrevious(isValid);
    const [debouncedSave] = lib_1.useDebouncedCallback(() => {
        save();
    }, 2500);
    react_1.useEffect(() => {
        if (isValid && !prevIsValid) {
            onValid();
        }
        else if (!isValid && prevIsValid) {
            onInvalid();
        }
    }, [isValid !== prevIsValid]);
    const showLoadingIndicator = !!(requestBuffer || error || loading);
    return (react_1.default.createElement(SendStepPanel_1.SendStepPanel, { step: step, activeStep: activeStep, title: "Write subject line", description: "Using fewer than 40-80 characters is recommended." },
        react_1.default.createElement(react_loops_1.For, { of: subjectLines }, (subjectLine, { isLast, index: i }) => {
            return (react_1.default.createElement(reactstrap_1.FormGroup, { className: "mb-2", key: `subjectLine${i}` },
                react_1.default.createElement(reactstrap_1.Input, { readOnly: loading, type: "text", name: `subjectLine${i + 1}`, disabled: !!disabled || allowableSubjectlines <= i, value: subjectLine || '', onChange: e => {
                        onSavePending();
                        const newSubjectLines = [...subjectLines];
                        newSubjectLines[i] = e.target.value;
                        onChange(newSubjectLines);
                        debouncedSave();
                        // if (subjectLines.length === 1) {
                        //   // this.setSubjectLine(e.target.value);
                        //   // this.debounceMutate(mutate, {
                        //   //   id: emailId,
                        //   //   latestSubjectLines: subjectLines,
                        //   // });
                        // } else {
                        //   // this.setSubjectLineOnMultivariate(i, e.target.value);
                        //   // const newLatestSubjectLines = subjectLines.slice();
                        //   // newLatestSubjectLines[i] = e.target.value;
                        //   // this.debounceMutate(mutate, {
                        //   //   id: emailId,
                        //   //   latestSubjectLines: newLatestSubjectLines,
                        //   // });
                        // }
                    } }),
                react_1.default.createElement(reactstrap_1.FormText, { className: "d-flex flex-row w-100" },
                    react_1.default.createElement(react_if_1.When, { condition: !!isLast },
                        react_1.default.createElement("div", { className: "text-left flex-grow-1" }, allowableSubjectlines <= i ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationTriangle }),
                            " This is disabled because this ESP does not support this many subject lines.")) : defaultSubjectLine &&
                            !defaultSubjectLineIsInUse &&
                            subjectLines.length - 1 === i ? (react_1.default.createElement("a", { href: "#", onClick: e => {
                                e.preventDefault();
                                const newSubjectLines = [...subjectLines];
                                newSubjectLines[i] = defaultSubjectLine;
                                onChange(newSubjectLines);
                            } }, "Use default subject line")) : defaultSubjectLine &&
                            subjectLines[i] === defaultSubjectLine ? (react_1.default.createElement(react_1.default.Fragment, null,
                            "This is the default subject line.",
                            ' ',
                            react_1.default.createElement("a", { href: "#", onClick: e => {
                                    e.preventDefault();
                                    const newSubjectLines = [...subjectLines];
                                    newSubjectLines[i] = '';
                                    onChange(newSubjectLines);
                                } }, "Clear"))) : (''))),
                    react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
                        react_1.default.createElement(react_if_1.When, { condition: showLoadingIndicator },
                            react_1.default.createElement(react_2.OsmosysDiv, { marginRight: true },
                                react_1.default.createElement(TinySaveIndicator_1.TinySaveIndicator, { error: error, success: !!data, loading: loading, leftIcon: true }))),
                        react_1.default.createElement(react_if_1.When, { condition: !!((subjectLines[i] || '').length > 70) },
                            react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true },
                                react_1.default.createElement(react_2.OsmosysTooltip, { label: "This subject line may be too long" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationTriangle, className: "mr-1 text-danger" })))),
                        react_1.default.createElement(react_2.OsmosysDiv, null,
                            (subjectLines[i] || '').length,
                            "/70")))));
        })));
    // return (
    //   <Mutation<Result>
    //     mutation={updateEmailLatestSubjectLinesQuery}
    //     onCompleted={() => {
    //       props.onSaveComplete();
    //       // this.setUpdateEmailLatestSubjectLineBuffer();
    //       // props.onChange(d.updateEmailLatestSubjectLines.latestSubjectLines);
    //     }}
    //     variables={{
    //       id: props.emailId,
    //       latestSubjectLines: props.subjectLines,
    //       useNewLoaderFeature:
    //         featureFlags.useNewLoaderForEmailSubjectLineMutation,
    //     }}
    //     // fetchPolicy="no-cache"
    //     // update={(cache, { data: { updateEmailLatestSubjectLines } }) => {
    //     //   const { email: emailData } = cache.readQuery({
    //     //     query: email,
    //     //     variables: { emailNumber: updateEmailLatestSubjectLines.emailNumber },
    //     //   });
    //     //   console.log({ emailData });
    //     //   cache.writeQuery({
    //     //     data: { email: { ...emailData, ...updateEmailLatestSubjectLines } },
    //     //     query: email,
    //     //   });
    //     // }}
    //   >
    //     {(mutate, result) => {
    //       return (
    //         <SubjectLinesInputContext.Provider
    //           value={{
    //             ...props,
    //             result,
    //             save: mutate,
    //           }}
    //         >
    //           {/* <SubjectLinesInputInner
    //             mutate={mutate}
    //             {...result}
    //             {...props}
    //             subjectLines={
    //               props.subjectLines.length === 0 || !props.subjectLines
    //                 ? ['']
    //                 : props.subjectLines
    //             }
    //             onChange={subjectLines => {
    //               if (!subjectLines || subjectLines.length === 0) {
    //                 props.onChange(['']);
    //               } else {
    //                 props.onChange(subjectLines);
    //               }
    //             }}
    //           /> */}
    //         </SubjectLinesInputContext.Provider>
    //       );
    //     }}
    //   </Mutation>
    // );
};
// interface IPropsInner extends IProps, MutationResult {
//   mutate: MutationFunction;
// }
// interface IAutoMutateHookArgs {
//   subjectLines: string[];
//   successful: boolean;
//   defaultSubjectLine: string;
//   onChange: (subjectLines: string[]) => void;
// }
// const useAutoMutateSubjectLines = ({
//   subjectLines,
//   successful,
//   onChange,
//   defaultSubjectLine,
// }: IAutoMutateHookArgs): [boolean] => {
//   const [requestBuffer, toggleRequestBuffer] = useToggle(false);
//   const [loadedOnce, toggleLoadedOnce] = useToggle(false);
//   const { save } = useSubjectLinesInputContext();
//   // Wait for subjectLines to change, then mutate after being debounced
//   // Wait for success state to change, then disable the requestBuffer after a debounce
//   useDebounce(
//     () => {
//       if (loadedOnce) {
//         toggleRequestBuffer(false);
//       }
//     },
//     2400,
//     [successful]
//   );
//   // After the function has loaded once, then mark the state as such, then check
//   // if there are zero subject lines, populating the defaultSubjectLine if needed
//   React.useEffect(() => {
//     if (!loadedOnce) {
//       // if (!subjectLines || subjectLines.length === 0) {
//       //   onChange([defaultSubjectLine || '']);
//       // }
//       toggleLoadedOnce(true);
//     }
//   }, [
//     defaultSubjectLine,
//     loadedOnce,
//     onChange,
//     subjectLines,
//     subjectLines.length,
//     toggleLoadedOnce,
//   ]);
//   return [requestBuffer];
// };
// // interface ISubjectLinesValidStateHook {
//   subjectLines: string[];
//   onValid: () => void;
//   onInvalid: () => void;
// }
// const useSubjectsLinesValidStateChanged = ({
//   subjectLines,
//   onValid,
//   onInvalid,
// }: ISubjectLinesValidStateHook): [boolean] => {
//   const [isValid, setIsValid] = React.useState<null | boolean>(null);
//   const previousIsValid = usePrevious(isValid);
//   // On valid status change, callback
//   React.useEffect(() => {
//     if (previousIsValid !== isValid) {
//       if (isValid) {
//         onValid();
//       } else {
//         onInvalid();
//       }
//     }
//   }, [isValid, onInvalid, onValid, previousIsValid]);
//   // On subjectLines change, validate
//   React.useEffect(() => {
//     if (!subjectLines || subjectLines.length === 0) {
//       setIsValid(false);
//       return;
//     }
//     const emptySubjectLine: string | undefined = subjectLines.find(
//       subjectLine => !subjectLine || subjectLine.length === 0
//     );
//     const longSubjectLine: string | undefined = subjectLines.find(
//       subjectLine => subjectLine.length > 200
//     );
//     if (emptySubjectLine !== undefined || longSubjectLine !== undefined) {
//       setIsValid(false);
//     } else {
//       setIsValid(true);
//     }
//   }, [subjectLines]);
//   return [!!isValid];
// };
// export const SubjectLinesInputInner: FC<IPropsInner> = ({
//   subjectLines,
//   disabled,
//   step,
//   activeStep,
//   defaultSubjectLine,
//   allowableSubjectlines,
//   onChange,
//   loading,
//   data,
//   error,
//   onValid,
//   onInvalid,
// }) => {
//   const defaultSubjectLineIsInUse: boolean =
//     defaultSubjectLine &&
//     subjectLines &&
//     !!subjectLines.find(sbjctLn => {
//       return sbjctLn.trim() === defaultSubjectLine.trim();
//     });
//   const [requestBuffer] = useAutoMutateSubjectLines({
//     defaultSubjectLine,
//     onChange,
//     subjectLines,
//     successful: !!data,
//   });
//   const { onSavePending } = useSubjectLinesInputContext();
//   useSubjectsLinesValidStateChanged({
//     onInvalid,
//     onValid,
//     subjectLines,
//   });
//   // const [isValid] = useSubjectsLinesValidStateChanged({
//   //   onInvalid,
//   //   onValid,
//   //   subjectLines,
//   // });
// };
//# sourceMappingURL=SubjectLinesInput.js.map